import { Reducer } from 'redux';
import { ILongSteelOrderItem } from '../long-steel-shopping-cart/types';
import { Types, ILongSteelOrderItemSearchState, ILastOrder } from './types';

const INITIAL_STATE: ILongSteelOrderItemSearchState = {
  searchedItems: [],
  searchingItems: false,
  searchingItemsError: false,
  searchingItemsSpreadsheetError: false,
  searchingItemsSpreadsheetItemsExceeded: false,
  searchingItemsLastOrderError: false,

  lastOrdersState: {
    loading: false,
    error: false,
    customerId: '',
    lastOrders: []
  }
};

type CustomAction = {
  type: Types;
  payload: {
    userId: string;
    customerId: string;
    lastOrders: ILastOrder[];
    selectedLastOrder: ILastOrder;
    searchedItems: ILongSteelOrderItem[];
    isExceeded: boolean;
  };
};

const reducer: Reducer<ILongSteelOrderItemSearchState, CustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.SEARCH_ITEM:
    case Types.SEARCH_ITEM_SPREADSHEET:
    case Types.SEARCH_ITEM_SPREADSHEET_MVP:
      return {
        ...state,
        searchedItems: [],
        searchingItems: true,
        searchingItemsError: false,
        searchingItemsSpreadsheetError: false,
        searchingItemsLastOrderError: false
      };

    case Types.CLEAN_ITEM_SPREADSHEET_MVP:
      return {
        ...state,
        searchedItems: [],
        searchingItems: false,
        searchingItemsError: false,
        searchingItemsSpreadsheetError: false,
        searchingItemsLastOrderError: false
      };

    case Types.SEARCH_ITEMS_FROM_LAST_ORDER:
      return {
        ...state,
        searchedItems: [],
        searchingItems: true,
        searchingItemsError: false,
        searchingItemsSpreadsheetError: false,
        searchingItemsLastOrderError: false,
        lastOrdersState: {
          ...state.lastOrdersState,
          selectedLastOrder: action.payload.selectedLastOrder
        }
      };

    case Types.FACELIFT_SEARCH_ITEM:
      return {
        ...state,
        searchingItems: true,
        searchingItemsError: false
      };

    case Types.FACELIFT_SEARCH_ITEM_SUCCESS:
      return {
        ...state,
        searchedItems: [
          ...state.searchedItems,
          ...action.payload.searchedItems
        ],
        searchingItems: false,
        searchingItemsError: false
      };

    case Types.FACELIFT_SEARCH_ITEM_FAILURE:
      return {
        ...state,
        searchedItems: state.searchedItems,
        searchingItems: false,
        searchingItemsError: true
      };

    case Types.REMOVE_SEARCHED_ITEM:
    case Types.ADD_SEARCHED_ITEM:
    case Types.SEARCH_ITEM_SUCCESS:
    case Types.SEARCH_ITEM_SPREADSHEET_SUCCESS:
    case Types.SEARCH_ITEMS_FROM_LAST_ORDER_SUCCESS:
      return {
        ...state,
        searchedItems: action.payload.searchedItems,
        searchingItems: false,
        searchingItemsError: false,
        searchingItemsSpreadsheetError: false,
        searchingItemsLastOrderError: false
      };

    case Types.SEARCH_ITEM_FAILURE:
      return {
        ...state,
        searchedItems: [],
        searchingItems: false,
        searchingItemsError: true
      };
    case Types.SEARCH_ITEM_SPREADSHEET_FAILURE:
      return {
        ...state,
        searchedItems: [],
        searchingItems: false,
        searchingItemsSpreadsheetError: true
      };
    case Types.SEARCH_ITEMS_FROM_LAST_ORDER_FAILURE:
      return {
        ...state,
        searchedItems: [],
        searchingItems: false,
        searchingItemsLastOrderError: true
      };

    case Types.CLEAN_ERRORS:
      return {
        ...state,
        searchingItemsError: false,
        searchingItemsSpreadsheetError: false,
        searchingItemsLastOrderError: false
      };

    // LAST ORDERS
    case Types.LOAD_LAST_ORDERS:
      return {
        ...state,
        lastOrdersState: {
          ...state.lastOrdersState,
          loading: true,
          error: false,
          lastOrders: [],
          customerId: action.payload.customerId
        }
      };
    case Types.LOAD_LAST_ORDERS_SUCCESS:
      return {
        ...state,
        lastOrdersState: {
          ...state.lastOrdersState,
          loading: false,
          error: false,
          lastOrders: action.payload.lastOrders
        }
      };
    case Types.LOAD_LAST_ORDERS_FAILURE:
      return {
        ...state,
        lastOrdersState: {
          ...state.lastOrdersState,
          loading: false,
          error: true,
          lastOrders: []
        }
      };
    case Types.CLEAN_LAST_ORDERS:
      return {
        ...state,
        lastOrdersState: {
          ...state.lastOrdersState,
          lastOrders: [],
          selectedLastOrder: undefined,
          customerId: ''
        }
      };
    case Types.SPREADSHEET_ITEMS_EXCEEDED:
      return {
        ...state,
        searchingItemsSpreadsheetItemsExceeded: action.payload.isExceeded
      };

    default:
      return state;
  }
};

export default reducer;
